const VotesTypes = {
  SUPPORT: 'support',
  NOT_SUPPORT: 'not_support',
  BUDGET: 'budget',
};

export default VotesTypes;
